import sutraLogo from "assets/img/sutraLogo.png";
import React, { useEffect } from "react";
import { useDispatch } from 'react-redux';
import { useLocation, withRouter } from 'react-router-dom';
import { resetApp } from "store/actions/applicationActions";
import NavbarCustom from "./../components/NavbarCustom";
import "./../util/analytics.js";
import { ProvideAuth, useAuth } from "./../util/auth.js";
import { Route, Router, Switch } from "./../util/router.js";
import ChangepassPage from "./changepass";
import DashboardPage from "./dashboard";
import ForgotpassPage from "./forgotpass";
import Privacy from './privacy';
import SigninPage from "./signin";
import Terms from "./terms";
import Documentation from 'pages/documentation'
import Support from 'pages/support'
import PricingPage from "./pricing";
import PurchasePage from "./purchase";
import SettingsPage from './settings'
import Build from './build'
import Widgets from "./widgets";
import NotFoundPage from './not-found'
import LoginSignUpPage from './loginSignup'
import Cohere from 'cohere-js'
import SigninSSOPage from 'pages/signin_sso'
import ReferralInvitation from 'pages/referralInvitation'

function App(props) {

  window.branch.init(process.env.REACT_APP_BRANCH_KEY, function(err, data) {
    // callback to handle err or data
  });

  
  const CircleIntegration = (props) => {

    const location = useLocation()

    useEffect(() => {

      console.log("PATH NAME: ", location)
      const isDashboard = location.pathname.startsWith('/dashboard')
      document.documentElement.style.setProperty('--circle-widget-visibility', isDashboard ? 'visible' : 'hidden');
    }, [location.pathname])


    return (<></>)
  }

  const HiddenNavbar = (props) => {
    const {location} = props;
    if (location.pathname.match('/about') || 
        location.pathname.match('/contact') || 
        location.pathname.match('/signin') || 
        location.pathname.match('/forgotpass') || 
        location.pathname.match('/sutra') || 
        location.pathname.match('/fitspo') ||
        location.pathname.match('/livestream') || 
        location.pathname.match('/changepass')) {
      return (
        <NavbarCustom
              bg="white"
              variant="light"
              expand="md"
              logo={sutraLogo}
        ></NavbarCustom>
      )
    }
    return null
  }
  const NavabarThatHides = withRouter(HiddenNavbar);

  const auth = useAuth();
  const dispatch = useDispatch();
  useEffect(() => {
    if (auth && auth.user === false) {
      dispatch(resetApp())
    }
  }, [auth, dispatch]);

  function noop() {}

  useEffect(() => {
    Cohere.init(process.env.REACT_APP_COHERE_KEY)
    if (process.env.NODE_ENV === 'production') {
      console.log = noop;
      console.warn = noop;
      console.error = noop;
    }
  }, [])
  return (
    <ProvideAuth>
      <Router>
          <>
          <CircleIntegration />
          <NavabarThatHides />

          <Switch>
            <Route exact path="/" component={SigninPage} />
            <Route exact path="/not-found" component={NotFoundPage} />
            <Route exact path="/support" component={Support} />
            <Route exact path="/pricing" component={PricingPage} />
            <Route exact path="/auth/signup" component={LoginSignUpPage} />


            <Route exact path="/documentation" component={Documentation} />

            <Route exact path="/purchase/:plan" component={PurchasePage} />
            <Route exact path="/settings/:section" component={SettingsPage} />

            <Route exact path="/signin" component={SigninPage} />
            <Route exact path="/authenticate" component={SigninSSOPage} />
            <Route exact path="/terms" component={Terms} />
            <Route exact path="/privacy" component={Privacy} />
            <Route exact path="/forgotpass" component={ForgotpassPage} />

            <Route exact path="/changepass" component={ChangepassPage} />
            <Route exact path="/build" component={Build} />

            <Route path="/dashboard" component={DashboardPage} />

            <Route path="/invite" component={ReferralInvitation}/>
            <Route path="/iframe/:username"
            render={props => {
              return (
                <Widgets fullwidth {...props}/>
              )
            }} />
            <Route path="/missy-iframe/:username"
            render={props => {
              return (
                <Widgets fullwidth {...props}/>
              )
            }} />
            <Route path="/:username" component={Widgets} />

            <Route
              component={({ location }) => {
                return (
                  <div
                    style={{
                      padding: "50px",
                      width: "100%",
                      textAlign: "center"
                    }}
                  >
                    The page <code>{location.pathname}</code> could not be found.
                  </div>
                );
              }}
            />
          </Switch>
        </>
      </Router>
    </ProvideAuth>
  );
}

export default App;
